import type { Asset } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

import { getColorName } from 'js/src/agent/utils';

/**
 * Render a color as a string with both numeric value and color name.
 * Example: "16777215(white)"
 */
export const renderColorAsString = (color: number): string => {
    return `${color}(${getColorName(color)})`;
};

/**
 * Format icon color maps into a readable string.
 * Returns a comma-separated list of colors with "and" for the last color.
 * Example: "16777215(white), 0(black) and 16711680(red)"
 */
export const formatIconColors = (asset: Asset): string => {
    if (!VideoData.isIconAsset(asset)) {
        return '';
    }

    let colors = '';
    asset.colorMaps.forEach((colorMap, index, array) => {
        if (colors) {
            if (index === array.length - 1) {
                colors += ' and ';
            } else {
                colors += ', ';
            }
        }
        colors += renderColorAsString(colorMap.targetColor || 0);
    });

    return colors;
};
